import styled from 'styled-components'
import { CSS } from 'ui/helpers'

const InputWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  padding: 10px 12px;
  border-bottom: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
  gap: 8px;

  input {
    width: 100%;
    height: 24px;
    border: none;
    outline: none;
    background: none;
    ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)};
  }

  i {
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    transition: color 0.3s;

    &:hover {
      color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
    }
  }
`

export const s = {
  InputWrapper
}
